import { render, staticRenderFns } from "./AdminLeadsByStatusNew.vue?vue&type=template&id=a8185524&scoped=true&"
import script from "./AdminLeadsByStatusNew.vue?vue&type=script&lang=js&"
export * from "./AdminLeadsByStatusNew.vue?vue&type=script&lang=js&"
import style0 from "./AdminLeadsByStatusNew.vue?vue&type=style&index=0&id=a8185524&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8185524",
  null
  
)

export default component.exports